import MyAppsPage from './MyAppsPage';

export default MyAppsPage;